import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { useRecoilValue } from 'recoil';
import { type CoverableInformationToUpdateDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa';
import { isLoggedOnSelector } from '../recoil/selectors/isLoggedOnSelector';
import { jobInfoAtom } from '../recoil/atoms/jobInfoAtom';

export function useSaveCoverableInformation(): {
    saveCoverableInformation: (updatedCoverable: CoverableInformationToUpdateDTO) => Promise<void>;
} {
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);
    const isLoggedOn = useRecoilValue(isLoggedOnSelector);

    const saveCoverableInformation = async (
        updatedCoverable: CoverableInformationToUpdateDTO
    ): Promise<void> => {
        await OnlineSalesUnauthenticated.saveCoverableInformation(
            jobNumber,
            updatedCoverable,
            sessionId,
            !isLoggedOn
        );
    };

    return { saveCoverableInformation };
}
